module.exports = __webpack_public_path__ + "img/star.b8e3e7bd.jpg";